import { Base } from '../base-component';

import './carousel-article-small-item.component.scss';
import SliderComponent from '../slider/slider.component';
import { MediaQueryService } from 'services/media-query.service';

export class CarouselArticleSmallItem extends Base {

	constructor(element){
		super(element)
	}

	init(){};

	bindEvents(){};

}



// WEBPACK FOOTER //
// ./components/carousel-article-small-item/carousel-article-small-item.component.ts